import { useContext } from "react";
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";
import { getDwk, timeFormat, getTotalFoodDetail } from "bodycodi/cmap/app/js/common";
import icon_right_arrow_red from "bodycodi/cmap/app/svg/icon_right_arrow_red.svg";

const MEAL_TYPE: {
  [key: string]: string;
} = {
  breakfast: "아침",
  lunch: "점심",
  dinner: "저녁",
  snack: "간식",
  morning_snack: "아침 간식",
  afternoon_snack: "점심 간식",
  late_night_snack: "야식",
};

const FoodTotal = ({ foodLensInfo, isList }: any) => {
  const { dispatch } = useContext(DispatchContext);

  const getDateFormat = (dts: string) => {
    const datetime = new Date(dts.replace(" ", "T"));
    const registerHour = datetime.getHours();
    const registerMin = datetime.getMinutes();
    const time = registerHour + ":" + registerMin;
    const ampm = timeFormat(time);
    const dwk = getDwk(datetime.getDay());

    return `${datetime.getFullYear()}년 ${
      datetime.getMonth() + 1
    }월 ${datetime.getDate()}일 (${dwk}) ${
      ampm.ampm
    } ${datetime.getHours()}:${datetime.getMinutes()}`;
  };

  const handleClickDtl = () => {
    if (isList) return;
    const totalDetailInfo = getTotalFoodDetail(
      foodLensInfo.foodLensPartInfos.map((v: any) => ({
        nutrition: v.nutrionInfo,
        eatAmount: v.eatAmount,
      }))
    );
    dispatch({
      type: "UPDATE",
      data: {
        comunityFoodDetail: {
          foodName: "전체",
          eatAmount: 1,
          unit: "",
          nutrition: totalDetailInfo,
        },
      },
    });
    dispatch({
      type: "POP_UP_OPEN",
      id: "COMUNITY_FOOD_DTL_POP",
      open: { comunityFoodDtlPop: true },
    });
  };

  return (
    <div className="comunity-content-food-total">
      {foodLensInfo.foodImageUrl && (
        <img className="food-img" src={foodLensInfo.foodImageUrl} alt="food" />
      )}
      <div className="food-total-info" onClick={handleClickDtl}>
        <p className="date">{getDateFormat(foodLensInfo.foodRegDts)}</p>
        <div className="kcal-info">
          <div className="type">{MEAL_TYPE[foodLensInfo.foodMealType]}</div>
          <p className="number">
            {foodLensInfo.foodCalorie}
            <span className="kcal">kcal</span>
          </p>
          {!isList && <img src={icon_right_arrow_red} alt="right_arrow" />}
        </div>
        {isList && (
          <div className="name-box">
            <span className="name">{foodLensInfo.foodLensPartInfos[0].foodName}</span>
            <span className="etc">
              {foodLensInfo.foodLensPartInfos.length > 1 &&
                ` 외 ${foodLensInfo.foodLensPartInfos.length - 1}건`}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default FoodTotal;
